import React, { useEffect } from 'react';
import {
  Form,
  FormInstance,
  DateSerialized
} from '@lightbeamhealth/blueprint-form';
import { Row, Col } from '../../../../grid';
import { StartDate } from '../date';
import { EndDate } from '../date';
import SelectMethod from '../method';
import Weekday from '../weekday';
import SelectLanguage from '../language';
import SelectTime from '../time';
import Timezone from '../timezone';
import { CardBlock, CardBreakout } from '../../card';
import {
  GetCurrentTZ,
  GetFormalDate,
  ShorthandDate
} from '../../../../libs/time';

interface EpxPreDiabetesData {
  method: string;
  language: string;
  start: string;
  end?: string;
  tz: string;
  isFixed: boolean;
  mode?: string;
  times: string[];
  days: number[];
  step?: number;
  isNutrition: boolean;
  isExercise: boolean;
  isWeight: boolean;
  isIntakeComplete: boolean;
}

type EpxPreDiabetesDataRaw = DateSerialized<
  EpxPreDiabetesData,
  'start' | 'end'
>;

const DATE_FORMAT = 'YYYY-MM-DD';
const { DeserializeDate, SerializeDate } = FormInstance;

interface EpxPreDiabetesFormProps {
  setForm?: (form: FormInstance<EpxPreDiabetesDataRaw>) => void;
  onSubmit?: (data: EpxPreDiabetesData) => void;
}

const EpxPreDiabetesForm = ({
  setForm,
  onSubmit: _onSubmit
}: EpxPreDiabetesFormProps): JSX.Element => {
  const serialize = (data: EpxPreDiabetesDataRaw): EpxPreDiabetesData => {
    return {
      ...data,
      start: SerializeDate(data.start, DATE_FORMAT),
      end: SerializeDate(data.end, DATE_FORMAT)
    };
  };
  const deserialize = (data: EpxPreDiabetesData): EpxPreDiabetesDataRaw => {
    return {
      ...data,
      start: DeserializeDate(data.start, DATE_FORMAT),
      end: DeserializeDate(data.end, DATE_FORMAT)
    };
  };

  const form = new FormInstance<EpxPreDiabetesDataRaw, EpxPreDiabetesData>(
    deserialize({
      method: 'message',
      language: 'en',
      start: GetFormalDate(ShorthandDate.Today),
      end: null,
      tz: GetCurrentTZ(),
      isFixed: false,
      mode: 'W',
      times: ['12:00'],
      days: [3],
      step: 1,
      isNutrition: true,
      isExercise: true,
      isWeight: true,
      isIntakeComplete: false
    }),
    { serialize, deserialize }
  );
  useEffect(() => {
    if (setForm) {
      setForm(form);
    }
  }, []);
  const onSubmit = (data: EpxPreDiabetesData): void => {
    _onSubmit(data);
  };
  return (
    <CardBlock bare>
      <Form form={form} onSubmit={onSubmit}>
        {(_props) => {
          return (
            <>
              <CardBlock>
                <Row>
                  <Col sm={12}>
                    <SelectMethod isMessageOnly />
                  </Col>
                  <Col sm={12}>
                    <SelectLanguage />
                  </Col>
                </Row>
              </CardBlock>
              <CardBlock>
                <Row>
                  <Col sm={12}>
                    <StartDate label="Start Date" name="start" fill />
                  </Col>
                  <Col sm={12}>
                    <EndDate label="End Date" name="end" />
                  </Col>
                  <Col sm={12}>
                    <SelectTime label="Message At" name="times[0]" />
                  </Col>
                  <Col sm={12}>
                    <Timezone label="Timezone" name="tz" fill />
                  </Col>
                </Row>
              </CardBlock>
              <CardBreakout>
                <Weekday name="days" minItems={1} inline />
              </CardBreakout>
            </>
          );
        }}
      </Form>
    </CardBlock>
  );
};

export default EpxPreDiabetesForm;
